<template>
  <div class="container-fluid">
    <div class="row">
      <el-container class="home-container">

        <el-header class="home-header">
          <div class="notice" v-if="messages.length > 1">
            <div  class="marquee" @click="showNoticeDetail">
              <div   class="notice-text" :class="{ 'animate-text': animate }">{{messages[0]}}</div>
            </div>
            <img  @click="showNoticeDetail"  class="blink" style="cursor:pointer;position: absolute;right: 15px;width: 20px;height: 20px;top: 32px;" src="/img/notice.png"/>
          </div>

          <span class="home_title"><img :src="$baseUrl+'img/paraverse-dev-logo.png'"/></span>
          <div class="fr user-tools">
            <el-dropdown :hide-on-click="false">
              <span class="el-dropdown-link">
                支持<i class="el-icon-caret-bottom"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="user-sub-menu">
                <el-dropdown-item>
                  <router-link class="a-fill" :to="{ path: '/support/index'}">
                    <i class="el-icon-notebook-2"></i><span>联系我们</span></router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <el-link :underline="false" href="https://docs.pingxingyun.com/project/5/" target="_blank">
                    <i class="el-icon-help"></i>
                    <span style="margin-left: 0">帮助链接</span>
                  </el-link>

                </el-dropdown-item>
                <el-dropdown-item>
                  <el-link :underline="false" href="https://www.pingxingyun.com/community/classify/" target="_blank">
                     <i class="el-icon-question"></i>
                     <span style="margin-left: 0">技术问答</span>
                  </el-link>

                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!--            <router-link class="normal" :to="{ path: 'https://www.pingxingyun.com/community/classify'}"><span>社区</span></router-link>-->
            <el-link class="normal" href="https://www.pingxingyun.com/community/classify" target="_blank">
              社区
            </el-link>
            <el-dropdown :hide-on-click="false">
              <span class="el-dropdown-link">
                费用<i class="el-icon-caret-bottom"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="user-sub-menu">
                <el-dropdown-item>
                  <router-link class="a-fill" :to="{ path: '/price/index'}"><i class="el-icon-coin"></i><span>价格详情</span>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link class="a-fill" :to="{ path: '/account/bill'}"><i class="el-icon-notebook-2"></i><span>账单总览</span>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link class="a-fill" :to="{ path: '/account/myOrder'}"><i
                    class="el-icon-tickets"></i>我的订单<span></span></router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link class="a-fill" :to="{ path: '/account/accountLog'}"><i
                    class="el-icon-money"></i><span>收支明细</span></router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link class="a-fill" :to="{ path: '/account/charge'}"><i
                    class="el-icon-bank-card"></i><span>充值</span></router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link class="a-fill" :to="{ path: '/account/coupon'}"><i
                    class="el-icon-present"></i><span>优惠券</span></router-link>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>

            <el-dropdown @command="handleCommand">
              <span class="el-dropdown-link home_userinfo">
              <i class="el-icon-s-custom"></i>
                <el-badge is-dot class="item" v-if="user.status == 2">{{user.accountId}}</el-badge>
                <span v-else>{{user.accountId}}</span><i class="el-icon-caret-bottom"></i>
              </span>
              <el-dropdown-menu slot="dropdown" class="user-sub-menu">
                <el-dropdown-item>
                  <router-link class="a-fill" :to="{ path: '/uac/basicInfo'}"><img
                    :src="$baseUrl+'img/info.png'"/><span>基本信息</span></router-link>
                </el-dropdown-item>
                <el-dropdown-item v-if="user.role=='2'">
                  <router-link class="a-fill" :to="{ path: '/uac/authc'}"><img :src="$baseUrl+'img/renzheng.png'"/>
                    <el-badge v-if="user.status == 2" class="badge-item" value="待认证">实名认证</el-badge>
                    <span v-else>实名认证</span></router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link class="a-fill" :to="{ path: '/uac/secure'}"><img :src="$baseUrl+'img/safe.png'"/><span>安全设置</span>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item>
                  <router-link class="a-fill" :to="{ path: '/uac/products'}"><img :src="$baseUrl+'img/peie.png'"/><span>用户配额</span>
                  </router-link>
                </el-dropdown-item>
                <el-dropdown-item  command="logout" divided><img :src="$baseUrl+'img/logout.png'"/><span>退出</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
        <el-container>
          <el-aside class="home-aside">
            <el-menu default-active="1-4-1" class="el-menu-vertical-demo" :collapse="isCollapse" router :unique-opened="true">
              <template v-for="item in this.routes">
                <template v-if="!item.hidden && item.meta.childIsPMenu
                 &&  item.meta.roleList.indexOf(user.role) >= 0
                  && (item.meta.roleList.indexOf(60) < 0 || (item.meta.roleList.indexOf(60) > 0 && (user.userId == '880027439680454656' || user.userId == '879770861261815808' || user.userId == '443167382534356992' || user.userId == '969185511111393280')) || (item.meta.roleList.indexOf(60) > 0 && (user.userId == '880027439680454656' || user.userId == '879770861261815808')))">
                  <el-submenu v-for="child in item.children" :index="child.name" :key="child.name">
                    <template slot="title"
                              v-if="!child.hidden  && !child.meta.childIsPMenu && child.meta.roleList.indexOf(user.role) >= 0
                             && child.meta.roleList.indexOf(60) < 0">
                      <i :class="child.iconCls"></i>
                      <span slot="title">
                      <router-link :to="child.path">
                         {{child.name}}
                        </router-link>
                    </span>

                    </template>
                    <template slot="title"
                              v-if="child.meta.childIsPMenu && child.meta.roleList.indexOf(user.role) >= 0">
                      <i :class="child.iconCls"></i>
                      <span slot="title">{{child.name}}</span>
                    </template>
                    <template v-for="(child1, child1Index) in child.children">
                      <template v-if="!child1.hidden && child1.meta.roleList.indexOf(user.role) >= 0">
                        <el-menu-item :key="child1Index">
                          <router-link v-if="child1.path == '/console/order/index'|| child1.path == '/console/client/index'"
                                      target="_blank" :to="child1.path">
                            {{child1.name}}
                          </router-link>
                          <router-link v-else :to="child1.path">
                            {{child1.name}}
                          </router-link>
                        </el-menu-item>
                      </template>
                    </template>
                  </el-submenu>
                </template>
                <template v-else-if="!item.hidden && item.meta.roleList.indexOf(user.role) >= 0
                &&  (item.meta.roleList.indexOf(60) < 0 || (item.meta.roleList.indexOf(60) > 0 && (user.userId == '880027439680454656' || user.userId == '879770861261815808'|| user.userId == '443167382534356992' || user.userId == '969185511111393280')))">
                  <el-menu-item :index="child.path" v-for="(child, childIndex) in item.children" :key="childIndex + child.name" style="text-align: left">
                    <i :class="child.iconCls"></i>
                    <span slot="title" style="display: inline-block;color: #fff"> {{child.name}}
                      </span>
                  </el-menu-item>
                </template>
              </template>
            </el-menu>
          </el-aside>
          <i style="height: 16px" v-if="isCollapse" @click="isCollapse = false"
             class="el-icon-s-fold shrinkBtn pointer"></i>
          <i style="height: 16px" v-else @click="isCollapse = true" class="el-icon-s-fold pointer"></i>
          <el-main>
            <el-breadcrumb separator-class="el-icon-arrow-right">
              <el-breadcrumb-item :to="{ path: '/console' }">首页</el-breadcrumb-item>
              <el-breadcrumb-item>{{this.$router.currentRoute.name}}</el-breadcrumb-item>
            </el-breadcrumb>
            <keep-alive>
              <router-view v-if="this.$route.meta.keepAlive">
              </router-view>
            </keep-alive>
            <router-view v-if="!this.$route.meta.keepAlive"></router-view>

          </el-main>
        </el-container>
      </el-container>
    </div>

    <el-dialog
      title="系统消息"
      v-if="messages.length > 1"
      :visible.sync="showNoticeDetailFlag"
      width="30%"
      center>
      <div style="padding: 20px;" v-html="messages[1].substring(1, (messages[1].length - 2))"></div>
    </el-dialog>
  </div>

</template>
<script>
  import {Message, MessageBox} from "element-ui";

  export default {
    data() {
      return {
        isCollapse: false,
        messages: [],
        animate: true,
        showNoticeDetailFlag: false
      }
    },
    mounted: function () {
      if (document.documentElement.clientWidth < 768) this.isCollapse = true;
      //用于用户驳回或者企业用户审核通过时，更新用户状态
    //  this.getUserInfo();
      //获取站内消息
      this.getNotice();
    },

    methods: {
      handleCommand(cmd) {
        var _this = this;
        if (cmd == 'logout') {
          MessageBox.confirm('注销登录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            localStorage.removeItem('preRoute');
            _this.$store.commit('logout');
            _this.$router.replace({path: '/'});
          }).catch(() => {
            Message.info("取消");
          });
        }
      },
      getNotice() {
        this.eventSource = new EventSource(this.$apiUrl + '/base/connect?username='+ this.user.accountId);

        this.eventSource.onmessage = (event) => {
          const newMessage = event.data;
          this.messages.push(newMessage);
          console.log(newMessage)
        };

        this.eventSource.onerror = (error) => {
          this.messages = [];
          console.error('SSE error:', error);
        };
      },
      showNoticeDetail(){
        this.showNoticeDetailFlag = true;
      }
    },

    computed: {
      user() {
        console.log(this.$store.state.user)
        return this.$store.state.user;
      },
      routes() {
        return this.$store.state.routes
      }
    }
  }
</script>
<style>
  .marquee {
    white-space: nowrap;
    overflow: hidden;
    box-sizing: border-box;
    position: absolute;
    right: 41px;
    top: 36px;
    width: 270px;
    cursor: pointer;
  }

  .notice-text {
    display: inline-block;
    padding-left: 100%;
    animation: scroll-text 10s linear infinite;
  }

  @keyframes scroll-text {
    0% {
      transform: translateX(0);
    }
    100% {
      transform: translateX(-100%);
    }
  }

  .animate-text {
    animation-play-state: running;
  }
  .badge-item .el-badge__content {
    top: 18px;
    right: 0;
  }

  .user-tools {
    margin-top: 13px;
    cursor: pointer
  }

  .home_userinfo {
    margin-right: 20px;
  }

  .a-fill {
    display: inline-block;
    width: 100%;
    height: 100%;
  }

  @media screen and (max-width: 768px) {
    .home-header .el-dropdown {
      margin-left: 10px !important;
    }

    .normal {
      margin-left: 10px !important;
    }

    .user-tools {
      margin-top: 18px !important;
    }

    .el-header {
      padding: 0 5px;
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      -ms-flex-negative: 0;
      flex-shrink: 0;
    }

    .home_userinfo {
      margin-right: 5px;
    }
  }
  .blink {
    animation: blinker 1s linear infinite;
  }

  @keyframes blinker {
    50% {
      opacity: 0;
    }
  }

</style>
